import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { AccountService } from '../../../services/account.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-change-password',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatButton,
    MatCardModule,
    RouterLink,
  ],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss',
})
export class ChangePasswordComponent {
  private fb = inject(FormBuilder);
  accountService = inject(AccountService);
  private router = inject(Router);
  private snackbar = inject(SnackbarService);
  private route = inject(ActivatedRoute);

  production = environment.production;
  height = 0;

  changePasswordForm = this.fb.group({
    oldPassword: [''],
    newPassword: [''],
    newPasswordConfirm: [''],
  });

  onSubmit(): void {
    this.accountService
      .changePassword(
        this.changePasswordForm.value.oldPassword ?? '',
        this.changePasswordForm.value.newPassword ?? '',
        this.changePasswordForm.value.newPasswordConfirm ?? '',
      )
      .subscribe({
        next: () => {
          this.snackbar.success('Password changed successfully');
          this.router.navigate(['/hours']);
        },
      });
  }
}
